import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils/animations';

const SectionTitle = ({ 
  title, 
  subtitle, 
  align = 'center',
  className = '' 
}) => {
  
  const alignments = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };
  
  return (
    <motion.div 
      className={`mb-12 ${alignments[align]} ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeInUp}
    >
      {subtitle && (
        <motion.p 
          className="text-primary-brown text-sm uppercase tracking-wider mb-2 font-medium"
          variants={fadeInUp}
        >
          {subtitle}
        </motion.p>
      )}
      <motion.h2 
        className="text-4xl md:text-5xl lg:text-6xl font-serif text-dark"
        variants={fadeInUp}
      >
        {title}
      </motion.h2>
    </motion.div>
  );
};

export default SectionTitle;